"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLanguage = exports.AVAILABLE_LANGUAGES = void 0;
exports.AVAILABLE_LANGUAGES = ['en-US', 'ja-JP'];
const toLanguage = (value) => {
    if (value === 'en-US' || value === 'ja-JP') {
        return value;
    }
    throw new Error();
};
exports.toLanguage = toLanguage;
